import { OpenSeadragon } from './component';

export { OpenSeadragon };

export default OpenSeadragon;



// WEBPACK FOOTER //
// ./src/components/openseadragon/index.jsx